// dependencies
import React from 'react'
import { Heading } from 'rebass'

// components
import Translate from 'App/components/text/Translate.js'

class H2 extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
    }
  }

  render () {
    return (
      <Heading as='h2' {...this.props} fontSize={16}>
        <Translate>{this.props.children}</Translate>
      </Heading>
    )
  }
}
export default H2
